module.exports = __webpack_public_path__ + "static/media/maintenance-item.431b42d7.svg";